module.exports = __webpack_public_path__ + "img/Hofmann2019.8e92267b.jpg";